/**************************************************
 * Nombre:       Footer_Llamado
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_habla.png'
import fondo_cell from '../../../Recursos/fondo_agendar.png'
import martillo from '../../../Recursos/martillo.png'
import {East} from '@mui/icons-material'
import {theme} from "../../../Tema";
import {LINKWASS, NEGRITA} from "../../../Constantes";
import {irUrl} from "../../../Utilidades/irUrl";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Footer_Llamado = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${sCell ? fondo_cell : fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top center',
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>

            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 4}}
                sx={{px: sCell ? 2 : 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 7}}>
                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontFamily: NEGRITA,
                            fontSize: sCell ? 32 : 40,
                            lineHeight: 1.1,
                            textAlign: sCell ? 'center' : 'left'
                        }}>HABLA
                        CON UN
                        EXPERTO</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 2}}>
                    <Button
                        onClick={() => irUrl(LINKWASS)}
                        endIcon={<East/>}
                    >
                        Chatear ahora mismo
                    </Button>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 2}}
                  sx={{
                      justifyContent: sCell ? 'center' : 'flex-end',
                      ml: sCell ? -4 : 8,
                      mr: sCell ? 0 : -8,
                      mt: sCell ? 2 : 8,
                      mb: sCell ? -12 : -12
                  }}>
                <img src={martillo} width={sCell ? '80%' : '200%'} height={'auto'} alt={'martillo'}/>
            </Grid>

        </Grid>
    )

}
export default Footer_Llamado